import { useState } from "react";

import Box from "@/components/Box";
import { ExternalTextLink } from "@/components/Links";
import OnboardingStatusChecker from "@/components/notifications/ui/OnboardingStatusChecker";
import { useOrganisationContext } from "@/contexts/organisations/OrganisationContext";
import ChevronComponent from "@/tpo/Chevron";
import Stack from "@/tpo/Stack";
import ButtonV2 from "@/v2/Buttons";

import StripeCalloutBanner from "./StripeCalloutBanner";

function Header() {
  return (
    <Box fontFamily="gilroyBold" fontSize={[28, 28, 36]} mb={[28]}>
      Link your bank account
    </Box>
  );
}

function Body() {
  const { organisation } = useOrganisationContext();
  const [checkingStatus, setCheckingStatus] = useState(false);

  return (
    <Stack gap={[20, 20, 40]}>
      <Box fontFamily="gilroyMedium" fontSize={[14, 14, 16]}>
        Why you should link your bank details to Stripe before ordering:
      </Box>
      <Box>
        <Box fontFamily="gilroyBold" fontSize={[16, 16, 18]}>
          Patient Pay access & Commission payments:
        </Box>
        <Box fontFamily="gilroyMedium" fontSize={[14, 14, 16]}>
          Linking your bank details via stripe unlocks the Patient Pay option, generating you
          commission. We need your bank details to know where to send your commission.
        </Box>
      </Box>
      <Box>
        <Box fontFamily="gilroyBold" fontSize={[16, 16, 18]}>
          Quicker Order Processing:
        </Box>
        <Box fontFamily="gilroyMedium" fontSize={[14, 14, 16]}>
          Without linking your bank details via Stripe, orders placed won't be shipped until payment
          is received.
        </Box>
      </Box>
      <Box>
        <Box fontFamily="gilroyBold" fontSize={[16, 16, 18]}>
          No automatic charges:
        </Box>
        <Box fontFamily="gilroyMedium" fontSize={[14, 14, 16]}>
          Linking your bank details does not trigger any payments - it simply verifies your account.
        </Box>
      </Box>
      <Stack gap={30}>
        <Box fontFamily="gilroyBold" fontSize={[16, 16, 18]}>
          Payment provider
        </Box>
        <StripeCalloutBanner fontSize={[14, 14, 16]} />
      </Stack>
      <ButtonV2
        as={ExternalTextLink}
        href={organisation?.onboardingUrl}
        target="_self"
        rel="noopener noreferrer"
        color="green"
        rightIcon={<ChevronComponent opacity={checkingStatus ? 0 : 1} />}
        type="button"
        size={["sm", "sm", "md"]}
        underline={false}
        mx="auto"
      >
        Complete Set Up
        <OnboardingStatusChecker onChange={active => setCheckingStatus(active)} />
      </ButtonV2>
    </Stack>
  );
}

export default Object.assign(
  {},
  {
    Header,
    Body,
  }
);
